// src/components/user/UserProfileManagement.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import ModuleAccessTab from './tabs/ModuleAccessTab';
import OrganizationAccessTab from './tabs/OrganizationAccessTab';
import CustomerAccessTab from './tabs/CustomerAccessTab';


import WabaAccessTab from './tabs/WabaAccessTab';
import Spare1Tab from './tabs/Spare1Tab';
import Spare2Tab from './tabs/Spare2Tab';

import {
  USER_PROFILE_ENDPOINT,
  ORG_LIST_ENDPOINT,
  ORG_USER_ASSIGN_ENDPOINT,
  ORG_USER_REMOVE_ENDPOINT,
  MODULE_LIST_ENDPOINT,  MODULE_ASSIGN_ENDPOINT, MODULE_REMOVE_ENDPOINT,
  CUSTOMER_LIST_ENDPOINT, CUSTOMER_ASSIGN_ENDPOINT, CUSTOMER_REMOVE_ENDPOINT, WABA_LIST_ENDPOINT, WABA_ASSIGN_ENDPOINT, WABA_REMOVE_ENDPOINT
} from '../../config/api';

function UserProfileManagement() {
  const { id, user_id, user_token } = useParams();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('organization');

  const [allOrgs, setAllOrgs] = useState([]);
  const [assignedOrgs, setAssignedOrgs] = useState([]);
  const [selectedOrgIds, setSelectedOrgIds] = useState([]);

  const [allModules, setAllModules] = useState([]);
  const [assignedModules, setAssignedModules] = useState([]);
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);


  const [allCustomers, setAllCustomers] = useState([]);
const [assignedCustomers, setAssignedCustomers] = useState([]);
const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);


const [allMessages, setAllMessages] = useState([]);
const [assignedMessages, setAssignedMessages] = useState([]);
const [selectedMessageIds, setSelectedMessageIds] = useState([]);

  useEffect(() => {
    if (!id || !user_id || !user_token) {
      alert('Missing parameters');
      return;
    }
    fetchUser();
    fetchOrganizations();
  }, [id, user_id, user_token]);



useEffect(() => {
  if (activeTab === 'modules') {
    fetchModules();
  } else if (activeTab === 'organization') {
    fetchOrganizations();
  } else if (activeTab === 'customers') {
    fetchCustomers();
  } else if (activeTab === 'waba') {
    fetchWabaMessages(); // ✅ THIS WAS MISSING
  }
}, [activeTab]);

const fetchCustomers = async () => {
  try {
    const res = await fetch(`${CUSTOMER_LIST_ENDPOINT}?user_id=${user_id}&user_token=${user_token}&target_id=${id}`);
    const data = await res.json();
    if (res.ok) {
      setAllCustomers(data.customers || []);
      setAssignedCustomers(data.assigned || []);
      setSelectedCustomerIds([]);
    } else {
      alert(data.error || 'Failed to fetch customers');
    }
  } catch {
    alert('Server error');
  }
};

const handleCustomerAssign = async () => {
  if (selectedCustomerIds.length === 0) return;
  try {
    const res = await fetch(CUSTOMER_ASSIGN_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id,
        user_token,
        target_id: id,
        customer_ids: selectedCustomerIds.join(',')
      })
    });
    const data = await res.json();
    if (res.ok) fetchCustomers();
    else alert(data.error || 'Failed to assign customers');
  } catch {
    alert('Server error');
  }
};

const handleCustomerRemove = async (cid) => {
  try {
    const res = await fetch(CUSTOMER_REMOVE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id,
        user_token,
        target_id: id,
        customer_id: cid
      })
    });
    const data = await res.json();
    if (res.ok) fetchCustomers();
    else alert(data.error || 'Failed to remove customer');
  } catch {
    alert('Server error');
  }
};


  const handleModuleRemove = async (moduleId) => {
  try {
    const res = await fetch(MODULE_REMOVE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id,
        user_token,
        target_id: id,
        module_id: moduleId
      })
    });
    const data = await res.json();
    if (res.ok) fetchModules();
    else alert(data.error || 'Failed to remove module');
  } catch {
    alert('Server error');
  }
};

  const fetchUser = async () => {
    try {
      const res = await fetch(USER_PROFILE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ id, user_id, user_token })
      });
      const data = await res.json();
      if (res.ok) setUser(data);
      else alert(data.error || 'Failed to load user profile');
    } catch {
      alert('Server error');
    }
  };

  const fetchOrganizations = async () => {
    try {
      const res = await fetch(`${ORG_LIST_ENDPOINT}?user_id=${user_id}&user_token=${user_token}&target_id=${id}`);
      const data = await res.json();
      if (res.ok) {
        setAllOrgs(data.organizations || []);
        setAssignedOrgs(data.assigned || []);
        setSelectedOrgIds([]);
      } else {
        alert(data.error || 'Failed to fetch organizations');
      }
    } catch {
      alert('Failed to load organizations');
    }
  };

  const handleAssign = async () => {
    if (selectedOrgIds.length === 0) return;
    try {
      const res = await fetch(ORG_USER_ASSIGN_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          user_id,
          user_token,
          target_id: id,
          org_ids: selectedOrgIds.join(',')
        })
      });
      const data = await res.json();
      if (res.ok) fetchOrganizations();
      else alert(data.error || 'Failed to assign organizations');
    } catch {
      alert('Server error');
    }
  };

  const handleRemove = async (orgId) => {
    try {
      const res = await fetch(ORG_USER_REMOVE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          user_id,
          user_token,
          target_id: id,
          org_id: orgId
        })
      });
      const data = await res.json();
      if (res.ok) fetchOrganizations();
      else alert(data.error || 'Failed to remove organization');
    } catch {
      alert('Server error');
    }
  };


  const fetchWabaMessages = async () => {
  try {
    const res = await fetch(`${WABA_LIST_ENDPOINT}?user_id=${user_id}&user_token=${user_token}&target_id=${id}`);
    const data = await res.json();
    if (res.ok) {
      setAllMessages(data.messages || []);
      setAssignedMessages(data.assigned || []);
      setSelectedMessageIds([]);
    } else {
      alert(data.error || 'Failed to fetch WABA messages');
    }
  } catch {
    alert('Server error');
  }
};


const handleWabaAssign = async () => {
  if (selectedMessageIds.length === 0) return;
  try {
    const res = await fetch(WABA_ASSIGN_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id,
        user_token,
        target_id: id,
        waba_ids: selectedMessageIds.join(',')
      })
    });
    const data = await res.json();
    if (res.ok) fetchWabaMessages();
    else alert(data.error || 'Failed to assign WABA messages');
  } catch {
    alert('Server error');
  }
};

const handleWabaRemove = async (messageId) => {
  try {
    const res = await fetch(WABA_REMOVE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id,
        user_token,
        target_id: id,
        message_id: messageId  // ✅ must be 'message_id'
      })
    });
    const data = await res.json();
    if (res.ok) fetchWabaMessages();
    else alert(data.error || 'Failed to remove WABA message');
  } catch {
    alert('Server error');
  }
};

  const fetchModules = async () => {
    try {
      const res = await fetch(`${MODULE_LIST_ENDPOINT}?user_id=${user_id}&user_token=${user_token}&target_id=${id}`);
      const data = await res.json();
      if (res.ok) {
        setAllModules(data.modules || []);
        setAssignedModules(data.assigned || []);
        setSelectedModuleIds([]);
      } else {
        alert(data.error || 'Failed to fetch modules');
      }
    } catch {
      alert('Server error');
    }
  };

  const handleModuleAssign = async () => {
    if (selectedModuleIds.length === 0) return;
    try {
      const res = await fetch(MODULE_ASSIGN_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          user_id,
          user_token,
          target_id: id,
          module_ids: selectedModuleIds.join(',')
        })
      });
      const data = await res.json();
      if (res.ok) fetchModules();
      else alert(data.error || 'Failed to assign modules');
    } catch {
      alert('Server error');
    }
  };

  if (!user) return <div className="container mt-4">Loading...</div>;

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4>User Profile: {user.name}</h4>
        <ul className="list-group mb-4">
          <li className="list-group-item"><strong>Phone:</strong> {user.phone}</li>
          <li className="list-group-item"><strong>Email:</strong> {user.email}</li>
          <li className="list-group-item"><strong>Status:</strong> {user.status === 1 ? 'Active' : 'Inactive'}</li>
        </ul>

        {/* Tab Navigation */}
        <ul className="nav nav-tabs mb-3">
          {[
            { key: 'organization', label: 'Organization Access' },
            { key: 'modules', label: 'Module Access' },
             { key: 'customers', label: 'Customer Access' },
            { key: 'waba', label: 'WABA' },
            { key: 'spare1', label: 'Spare1' },
            { key: 'spare2', label: 'Spare2' }
           
          ].map(tab => (
            <li className="nav-item" key={tab.key}>
              <button
                className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>

{activeTab === 'customers' && (
  <CustomerAccessTab
    allCustomers={allCustomers}
    assignedCustomers={assignedCustomers}
    selectedCustomerIds={selectedCustomerIds}
    setSelectedCustomerIds={setSelectedCustomerIds}
    handleCustomerAssign={handleCustomerAssign}
    handleCustomerRemove={handleCustomerRemove}
  />
)}
    {activeTab === 'organization' && (
  <OrganizationAccessTab
    allOrgs={allOrgs}
    assignedOrgs={assignedOrgs}
    selectedOrgIds={selectedOrgIds}
    setSelectedOrgIds={setSelectedOrgIds}
    handleAssign={handleAssign}
    handleRemove={handleRemove}
  />
)}

{activeTab === 'modules' && (
  <ModuleAccessTab
    allModules={allModules}
    assignedModules={assignedModules}
    selectedModuleIds={selectedModuleIds}
    setSelectedModuleIds={setSelectedModuleIds}
    handleModuleAssign={handleModuleAssign}
    handleModuleRemove={handleModuleRemove}
  />
)}

{activeTab === 'waba' && (
  <WabaAccessTab
    allMessages={allMessages}
    assignedMessages={assignedMessages}
    selectedMessageIds={selectedMessageIds}
    setSelectedMessageIds={setSelectedMessageIds}
    handleWabaAssign={handleWabaAssign}
    handleWabaRemove={handleWabaRemove}
  />
)}
{activeTab === 'spare1' && <Spare1Tab />}
{activeTab === 'spare2' && <Spare2Tab />}
      </div>
    </>
  );
}

export default UserProfileManagement;
